// extracted by mini-css-extract-plugin
export default {"main":"Stage7_main__DVbQ8","grid":"Stage7_grid__aZGnt","btn":"Stage7_btn__-K+B5"};